import { Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgOption } from '@ng-select/ng-select';
import { ValueAccessorBase } from '../_entities/value-accessor-base';



@Component({
  selector: 'lean-select',
  templateUrl: './lean-select.component.html',
  styleUrls: ['./lean-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: LeanSelectComponent,
    multi: true,
  }],
})

export class LeanSelectComponent extends ValueAccessorBase<any> implements OnInit {


  @Input() label : string = null;
  @Input() bindLabel = '';
  @Input() multiple = "false" ;
  @Input() bindValue = "" ;
  @Input() placeholder = 'Selectionner ...' ;
  //[(ngModel)]="cityFilter">

  _items = [];
  @Input() set items(_items: any) {
    if (_items !== null && _items !== undefined) {
      this._items = _items;
    }
  }

  private _options : Array<NgOption>;
  @Input()
  public set options(value : Array<NgOption>){
    this._options = value;
  }

  @Output() onChange = new EventEmitter<any>();

  constructor() {
    super();
  }

  ngOnInit() {

  }

  change(){
    this.onChange.emit(null);
  }

}
